import React, { useEffect, useState, useContext } from "react";
import "../Styles/styles.css";
import "../Styles/Navbar.css";
import SpecificStyle from "../Components/Styles/SpecificStyle";
import Bag from "../Assets/Images/Bag.png";
import Vector from "../Assets/Images/Vector.png";
import { ButtonContainer } from "../Components/Shared/ButtonComponent";
import { useLocation, useNavigate } from "react-router-dom";
import SimilarMaleStyles from "../Components/Styles/SimilarMaleStyles";
import AddToCart from "./AddToCart";
import NumberFormat from "react-number-format";
import Form from "../Components/Form/Form";
import { MakeTailoringContext } from "../context/MakeTailoringContext";

import { AddToCartContext } from "../context/AddToCartContext";
import { CartModalContext } from "../context/CartModalContext";
import TailoringContext from "../context/TailoringContext";
import { ImSpinner2 } from "react-icons/im";
import useTailoring from "../hooks/useTailoring";
import { UserContext } from "../context/userContext";
import { toast } from "react-toastify";

export default function Product() {
  const [similarStyles, setSimilarStyles] = useState(null);

  const toastOptions = {
    hideProgressBar: true,
    position: "top-right",
    theme: "colored",
  };

  const location = useLocation();
  const navigate = useNavigate();

  const { selectedSize, setProductId } = useContext(MakeTailoringContext);
  const { showCart, setShowCart } = useContext(CartModalContext);
  const {
    addToCartFormik,
    setCartProductId,
    setDelivery,
    setSize,
    setFrom_state,
    setTo_State,
    setToLga,
    setDelivery_address,
    setPick_up,
    setwhatsappContact,
    setOrderID
  } = useContext(AddToCartContext);
  const {isLoggedIn} = useContext(UserContext)
  const { loader } = useContext(TailoringContext);


  let orderImage = location.state?.src;
  let chooseSex = location.state?.id;
  let styleName = location.state?.stylename;
  let amount = location.state?.price;
  let uniqueId = location.state?.uniqueId;
  let description = location.state?.description;
  let style_quantity = location.state?.style_quantity;
  let category = location.state?.category;

  const { handleSimilarStyles } = useTailoring();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    orderImage = location.state?.src;
  }, [orderImage]);

  useEffect(() => {
    handleSimilarStyles(category).then((res) => {
      setSimilarStyles(res?.data.tailoring);
    });
    // eslint-disable-next-line
  }, []);

  const handleAddToCart = () => {
    setCartProductId(uniqueId);
    addToCartFormik.handleSubmit("090");
  };


const handleMakeOrder  = () => {
  if(isLoggedIn){
    addToCartFormik.handleSubmit("090")
    setProductId(uniqueId);
    setOrderID(uniqueId)
    navigate("/tailoring/orderdetails", {
      state: {
        src: orderImage,
        stylename: styleName,
        id: chooseSex,
        price: amount,
        uniqueId: uniqueId,
        description: description,
      },
    });
  } else {
    toast.error("Please Login To Proceed", toastOptions);
  }
  }
  return (
    <>
      <div id="product" className="product col-12">
        <div className="product_banner col-12">
          <SpecificStyle
            orderImage={orderImage}
            chooseSex={chooseSex}
            styleName={styleName}
          />

          <div className="p_div">
            <div className="p_description">
              <p className="text-capitalize">{styleName}</p>
              <p>{description}</p>
              <p>
                {" "}
                <NumberFormat
                  value={amount}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"₦"}
                />
              </p>
              <p>
                <span className="c_star">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </span>
                <span className="p_star">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </span>
                <span>(124 customer ratings)</span>
              </p>
{/* 
              <p className="p_content">
                Our state-of-the-art Non Iron dress shirt in mid blue twill
                ensures a high-quality fit and feel throughout the day with
                minimal effort. The two-ply fabric and taped seams provide
                enhanced comfort while also maintaining a smooth, pucker-free
                finish, and the densely woven shirt gives a heavy body and is
                very opaque. Wear this gem whenever you want to impress your
                surroundings and make a smooth statement, this is definitely a
                dress shirt worthy of its name. Made to your measurements.
              </p> */}
              <div className="custom_form">
                <Form
                  chooseSex={chooseSex}
                  {...{
                    setDelivery,
                    setSize,
                    setFrom_state,
                    setTo_State,
                    setToLga,
                    setDelivery_address,
                    setPick_up,
                    style_quantity,
                    setwhatsappContact
                  }}
                />
              </div>

              <div className="div_btn">
                <ButtonContainer
                type="button"
                  disabled={selectedSize === "Select a Size"}
                  className={selectedSize === "Select a Size" && "disabled"}
                  onClick={handleMakeOrder}
                >
                  Proceed to Pay
                </ButtonContainer>

                <button style={{minWidth: "150px"}}
                  disabled={selectedSize === "Select a Size"}
                  type="button"
                  onClick={() => {
                    handleAddToCart();
                  }}
                >
                  {loader ? <ImSpinner2 size={25} className="spin" /> :
                  <div><img alt="" src={Bag} /> <span>Add to Cart</span></div>}
                </button>
              </div>
              <div className="vector_div">
                <span>
                  <img alt="" src={Vector} />
                  <span>Fit Guarantee</span>
                </span>
              </div>
              <div className="fabric_desc">
                <div className="dbr"></div>
                <p>Fabric: Olympia, Multi Colored Ankara</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 view_product">
          <div className="product_con col-12">
            <p>Similar Styles...</p>
            <p>View More</p>
          </div>

          {loader ? (
            <div className="text-center">
              <ImSpinner2 size={40} className="spin" />
            </div>
          ) : (
            <SimilarMaleStyles {...{ category, similarStyles }} />
          )}
        </div>
        <div className={showCart ? "cart-menu-expanded" : "cart-menu"}>
          <div>
            <AddToCart {...{ setShowCart }} />
          </div>
        </div>
      </div>
    </>
  );
}
